import classNames from 'classnames'
import { useMemo } from 'react'

import {
  UNIT_STATUS_ACTIVE,
  UNIT_STATUS_CANCELLED,
  UNIT_STATUS_INACTIVE,
  UNIT_STATUS_PENDING_CANCELLATION
} from '@apps-common/config/unit-filter'

interface IProps {
  status: string
}

export const UnitStatusWidget: React.FC<IProps> = ({ status }) => {
  const classes = useMemo(() => {
    switch (status) {
      case UNIT_STATUS_ACTIVE.value:
        return 'bg-success text-on-success'

      case UNIT_STATUS_INACTIVE.value:
        return 'bg-info text-on-info'

      case UNIT_STATUS_PENDING_CANCELLATION.value:
        return 'bg-warning text-on-warning'

      case UNIT_STATUS_CANCELLED.value:
        return 'bg-error text-on-error'

      default:
        return 'bg-border text-text'
    }
  }, [status])

  const text = useMemo(() => {
    if (
      [UNIT_STATUS_ACTIVE.value, UNIT_STATUS_INACTIVE.value, UNIT_STATUS_PENDING_CANCELLATION.value, UNIT_STATUS_CANCELLED.value].includes(
        status
      )
    ) {
      return status
    }

    return 'unknown'
  }, [])

  return (
    <div className='flex items-center justify-start'>
      <div className={classNames(classes, 'capitalize text-[0.8rem] px-2 py-1 rounded-lg min-w-[74px] text-center')}>{text}</div>
    </div>
  )
}
